import { useState as v } from "react";
import { useId as A, useSafeLayoutEffect as s, useForkRef as S } from "../../../ariakit-react-utils/esm/hooks.js";
import { createHook as h, createComponent as F, createElement as T } from "../../../ariakit-react-utils/esm/system.js";
import { flushSync as m } from "react-dom";
function c(n, e) {
  const t = setTimeout(e, n);
  return () => clearTimeout(t);
}
function g(n) {
  let e = requestAnimationFrame(() => {
    e = requestAnimationFrame(n);
  });
  return () => cancelAnimationFrame(e);
}
function l() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return e.join(", ").split(", ").reduce((o, r) => {
    const i = parseFloat(r || "0s") * 1e3;
    return i > o ? i : o;
  }, 0);
}
const N = h((n) => {
  let {
    state: e,
    ...t
  } = n;
  const o = A(t.id), [r, i] = v(null);
  s(() => {
    var a;
    if (e.animated) {
      if (!((a = e.contentElement) != null && a.isConnected)) {
        i(null);
        return;
      }
      return g(() => {
        i(e.open ? "enter" : "leave");
      });
    }
  }, [e.animated, e.contentElement, e.open]), s(() => {
    if (!e.animated || !e.contentElement || !r || r === "enter" && !e.open || r === "leave" && e.open) return;
    if (typeof e.animated == "number") {
      const D = e.animated;
      return c(D, () => m(e.stopAnimation));
    }
    const {
      transitionDuration: a,
      animationDuration: d,
      transitionDelay: p,
      animationDelay: y
    } = getComputedStyle(e.contentElement), E = l(p, y), C = l(a, d), u = E + C;
    if (u)
      return c(u, () => m(e.stopAnimation));
  }, [e.animated, e.contentElement, r, e.open, e.stopAnimation]);
  const f = e.mounted || t.hidden === !1 ? t.style : {
    ...t.style,
    display: "none"
  };
  return t = {
    id: o,
    "data-enter": r === "enter" ? "" : void 0,
    "data-leave": r === "leave" ? "" : void 0,
    hidden: !e.mounted,
    ...t,
    ref: S(o ? e.setContentElement : null, t.ref),
    style: f
  }, t;
}), q = F((n) => {
  const e = N(n);
  return T("div", e);
});
process.env.NODE_ENV !== "production" && (q.displayName = "DisclosureContent");
export {
  q as DisclosureContent,
  N as useDisclosureContent
};
//# sourceMappingURL=disclosure-content.js.map
